export default {
  'home': 'Homepage',
  course: 'Courses',
  live: 'Live',
  short_video: 'Clips',
  public_exam: 'Public Exam',
  training_class: 'OMO Classes',
  infor_list: 'News',
  Knowledge_lib: 'Library',
  intelligent_circle: 'Knowledge Circle',
  learning_footprint: 'Learning Footprint',
  my_course: 'Courses',
  my_exam: 'Exams',
  learn_map: 'Learning Map',
  zhi_niao: "Smart Learn",
  exam: 'Exams',
  EBOOK: 'E-Books',
  i_want_public: 'I want to post',
  questionnaire: 'Forms',
  new_questionnaire: 'New questionnaire',
  my_training_class: 'OMO Classes',
  my_questionnaire: 'Forms',
  practice_train: 'Practical Trainings',
  my_homework: 'My homework',
  training_project: 'Training Programs',
  learn_tasks: 'Learning Tasks',
  more: 'View more',
  error: 'Request error',
  fail: 'Failed to request',
  confirm: 'Confirm',
  confirm_empty: 'OK',
  cancel: 'Cancel',
  check: 'View',
  practice: 'Practical operation',
  stage_learn_project: "Stage learning project",
  nonsupport: 'This resource cannot be viewed on Smart Learn web version for now, please stayed tuned!',
  no_support_vs: 'This resource cannot be viewed for now, please stayed tuned!',
  intelligent_portal: 'My face-to-face courses cannot be accessed by Smart Portal for now, please use Smart Learn App',
  playback: 'Replay',
  back: 'Return',
  commend: 'Recommendations',
  exam_score: 'Exam score',
  ten_thousand: '10,000',
  learned: 'Learned',
  no_learned: 'Not learned',
  has_learned: 'Learned',
  is_passed: 'Approved',
  fail_passed: 'Rejected',
  not_passed: 'Fail',
  to_be_approved: 'Pending approval',
  score: 'points',
  no_score: 'No rating',
  Intelligent_accompaniment: 'AI Sparring',
  conmment_score: 'Rating:',
  submit__score: 'Submit',
  all: 'All',
  i_got_it: 'Confirm',
  book_tip: 'This courseware is an e-book, which is currently only can be studied on Smart Learn App. Please learning the courseware in the Smart Learn App.' ,
  no_permission: 'Sorry, you do not have permission to view this course',
  go_training_programs: 'This resource is part of the training program content. To ensure the validity of the data, please go to the corresponding training program to learn!' ,
  need_accept_oversight: 'Sorry! This course can only be studied under supervision. You can only learning on App.' ,
  go_app_learn: 'To ensure the validity of the learning data, please learn with Smart Learn App.' ,
  video_learn: 'Video proctoring is required for this course, so you must learn it in Smart Learn App. Please open the Smart Learn App to learn.' ,
  need_sign: 'This course requires signature and must be signed in Smart Learn App. Please learning the course in the Smart Learn App.' ,
  lift_lockdown: 'The upper limit for screenshots has been reached. You are not allowed to re-enter the course. Please contact the administrator to lift the ban',
  punch_in_completed: 'Complete the punch verification',
  please_punch_in_completed: 'Please complete the punch verification',
  verify_complete: 'Verified',
  Initializing: 'Initializing...',
  intelligent_detection: 'Intelligent detecting...',
  click_complete_verification: 'Click to verificate',
  second: 's',
  enter_verification_code: 'Please enter the verification code',
  captcha_error: 'Incorrect verification code',
  verification_code: 'Verification Code',
  submit_success: 'Submitted successfully',
  author: 'Author',
  producer: 'Producer',
  brief_introduction: 'Introduction:',
  pack_up_detail: 'Show less details',
  spread_details: 'Show more details',
  all_comments: 'All comments',
  headline_Review: 'Headline comment',
  latest_comments: 'Latest comment',
  no_comments: 'No one has commented yet',
  publish_Comment: 'Comment',
  no_more_comments: 'No more comments',
  see_more_comments: 'View more comments',
  submit_comment_tip: 'Darling, at least 5 characters are need for the submission',
  disabled_drag: 'This course is set to prohibit dragging',
  tip_screen: 'Please always keep the course window maximized, otherwise you will not be able to start learning',
  goto_complete: 'Please finish course learning first',
  network_anomaly: 'Network anomaly',
  abnormal: 'Abnormal',
  no_data: 'No data',
  login_password: "Please enter login password",
  enter_password: 'Please enter your password',
  enter_password_again: 'Incorrect password, please re-enter',
  enter_password_info: "Please enter your password to verify identity",
  next_txt: 'Next',
  not_started: 'Not Started',
  ongoing: 'Ongoing',
  Living: 'Live',
  is_over: 'Ended',
  playing_back: 'Replay',
  invalid_live: 'Invalid live',
  living: 'On-live',
  finished: 'Completed',
  no_finished: 'Unfinished',
  returned: 'Returned',
  training_time: 'Training Time',
  format_time_year: 'YYYY-MM-DD',
  format_time_mouth: 'MM-DD',
  this_time_score: "Score for this test",
  affirm_submit: 'Whether to confirm submission',
  upload_file: 'Upload',
  files: 'File',
  title_name: 'Name',
  typeof: 'Type',
  support: "Like",
  like_num: 'Likes',
  clock_support: 'Like',
  select_more: 'View All',
  unread: 'Unread',
  my_news: 'My messages',
  my_setting: 'Settings',
  user_center: "Personal Center",
  my_circle: 'My Circle',
  no_nickName: 'No nickname',
  no_content: 'No content yet',
  delete: 'Delete',
  go_face_class: 'Go to the face-to-face course now?' ,
  go_exam: 'Go to the exam and start answering questions now?' ,
  go_live: 'Go to the live now?' ,
  go_learn_map: 'Go to the learning map now?' ,
  go_intelligent_circle: 'Go to the post now?' ,
  web_cannot_open: "The page cannot open this type of information",
  use_zhiniao_app: 'Please use Smart Learn to read this message',
  intelligent_portal_home: '01Web - Smart Portal homepage',
  opening_time: 'Time',
  day: 'day(s)',
  hours: 'h',
  minutes: 'm',
  seconds: 's',
  no_limits: 'Unlimited',
  live_time: 'Live time',
  cut_off_time: 'Deadline:',
  training_matters: 'Training events',
  face_class_Introduction: 'OMO Class Introduction',
  schedule: 'Schedule',
  honor_rank: 'Honor list',
  discuss: 'Discussion',
  homeWork: 'Assignments',
  certificate_completion: 'Certificates',
  head_master: 'Instructor',
  head_master_colon: 'Instructor: ',
  training_matters1309: '1309Web-View training events',
  check_training_Intro1310: '1310Web-View training introduction',
  check_schedule1304: '1304Web-View schedule',
  check_rank1306: '1306Web-View honor list',
  go_discuss1307: '1307Web-Enter the discussion forum',
  show_training_detail1301: '1301Web-Display training class details',
  trainclass13: '13Web-Training class',
  web_learn_task04: '04Web-Learning tasks',
  logout: "Log out",
  circle: 'Circle',
  search_circle: 'Search circle',
  all_circle: 'All Circles',
  concel_empty: 'Cancel',
  confirm_txt: "OK",
  copy_success: 'face-to-face courses',
  copy_failed: "Copy failed",
  insert_picture: 'Insert image',
  input_text: 'Please enter the body content',
  search_name_number: 'Search by name / employee number',
  not_found_search: "Search entry not found",
  enclosure_title: 'Attachment name',
  url: 'Link',
  operation: 'Operation',
  posted: 'Post',
  my_post: 'My posts',
  undercarriage: 'Remove',
  setting_success: 'Set successfully',
  setting_failed: 'Set failed',
  undercarriage_success: 'Removed successfully',
  undercarriage_failed: 'Failed to remove',
  one_minutes_ago: '1 minute ago',
  much_minutes_ago: '{time, plural, =0 {no minutes.} =1 {one minute.} other {# minutes.}} ago',
  much_hours_ago: '{hourGap, plural, =0 {no hours.} =1 {one hour.} other {# hours.}} ago',
  min_length_limit: 'Write at least {minLength} words for submission',
  cancel_topping: 'Cancel sticking to top',
  set_topping: 'Stick to top',
  cancel_essence: 'Cancel highlight',
  set_essence: 'Set as highlight',
  practical_training: "Practical Trainings",
  filled_in: 'Filled',
  no_filled_in: 'To be filled',
  not_open: "Not opened",
  summary_newcomers: "Newcomer weekly summary",
  training_time_colon: "Training time: ",
  unopened: 'Not open',
  daily_summary_newcomers: 'Newcomer daily summary',
  mentor_name: "Instructor's name:",
  interview_track_record: 'Interview follow-up form',
  evaluated: 'Evaluated',
  to_be_evaluated: 'To be evaluated',
  reviewed: 'Reviewed',
  to_be_reviewed: 'To be reviewed',
  formal_exam: 'Formal Exam',
  mock_exam: 'Mock Exam',
  test_num: '{testNum, plural, =0 {no Questions} =1 {one Question} other {# Questions}}',
  total_score: 'Full score',
  not_yet: 'Not yet',
  anchor: 'Anchor:',
  total_pics: '{smallImgList, plural, =0 {no images} =1 {one image} other {# images}} in total',
  collection: 'Favorites',
  cover_map: 'Cover image',
  enterprise_course: 'Corporate class',
  no_resources_found: 'No resources searched',
  learn_map11: '11Web-Learning map',
  my_learn_map: 'My Learning Maps',
  not_learning: 'Not learned',
  other: 'Others',
  posts_count: 'Post(s):',
  follow_count: 'Follower(s):',
  followed: 'Followed',
  follow: 'Follow',
  concel_follow: 'Unfollowed successfully',
  follow_success: 'Followed successfully',
  confirm_concel_follow: 'Unfollow?' ,
  Background_process_error: 'Background processing error',
  anchor_top_list: 'Circle owner leaderboard',
  rank: 'Leaderboard',
  Recent_classes: 'Recently Started',
  most_popular: 'Hot',
  registration_time: 'Registration period',
  reported_limit: 'Capacity',
  no_training_class: 'No OMO class yet!',
  validation_failed: 'Verification failed',
  course_list07: "07Web-Course details page",
  limit_value_tip: 'Thank you for your learning, you have studied for more than {limitValue, plural, =0 {no hours} =1 {one hour} other {# hours}} To ensure efficiency, please take a break and come back tomorrow!' ,
  scored: 'Rated',
  mark_score: 'I want to rate',
  learn_order: 'This training program needs to be studied in strict order',
  go_continue: 'Please continue learninging the following resources',
  click_catalog0703: '0703Web-Click directory entry',
  give_mark0706: '0706Web-Participate rating',
  show_course_datail0701: '0701Web-Display course detail page',
  current_project_completed: 'The current project is closed',
  about_to_quit: 'The end time of training program falls You are about to quit learning',
  countdown: 'OK({countNum}s)',
  get_exam_fail: 'Network error. Failed to access to examination resources',
  not_allow_quit: 'You are not allowed to quit during the exam',
  exam_detail: 'Exam Details',
  select_location: 'Please select location first',
  custom_address: 'Customize address',
  add_location: 'Add geographic location',
  effective_range: 'Valid range',
  metre: 'meter/meters',
  search: 'Search',
  system_error: 'System error, please try again later',
  Live_not_started: 'The live has not started, please try again later',
  spread: 'Show more',
  pack_up: 'Show less',
  Login_recovery: 'Login recovery',
  browser_version_low: 'Sorry, your browser version is too low, which may affect the use of some functions of Smart Learn web version. Please upgrade to IE{version} or above or use Chrome to open Smart Learn web version.' ,
  click_pic0104: '0104Web-Click avatar',
  check_wallet0102: '0102Web-View wallet',
  my_setting0106: '0106Web-My settings',
  quit_login0107: '0107Web-Log out',
  my_reimbursement: 'My reimbursement',
  my_class_audit: 'My class review',
  wallet: 'Wallet',
  check_mes0103: '0103Web-View message',
  news: 'Messages',
  enter_search_keywords: 'Please enter the keyword / live ID / clip ID',
  loading: 'Loading...',
  not_support_upload: 'There are files that cannot be uploaded, please select again',
  upload_attachment: 'Upload attachment',
  please_enter: 'Please enter',
  multiple_choice_qus: 'Multiple choice question',
  single_choice_qus: 'Single choice question',
  judgment_qus: 'Judgment questions',
  subjective_qus: 'Subjective questions',
  photographs: 'Picture questions',
  completion: 'Gap filling questions',
  matching: 'Matching questions',
  attachment: 'Attachment questions',
  customs_clearance_task: 'Clear task',
  sparring_robot: 'Training robot',
  learn: 'Learn',
  share: 'Share',
  make_comments: "Rated {typeName}'{name}'",
  collect: 'Add to favorites',
  watch: 'Watch',
  host: 'Host',
  send_gift: 'Sent a gift',
  completion_graduation: 'Complete a course',
  breakthrough_complete: 'Level cleared',
  participate_in: 'Participate',
  read: 'Read',
  achieve_score: ', grade: {score}',
  take_part_in: 'Participate',
  no_corporate_identity: "Sorry, you don't have a corporate identity and can't use the Smart Learn web version",
  no_homepage: "Sorry, you don't have a visible homepage and can't use the Smart Learn web version",
  reset_password: 'Reset password',
  access_time: 'Time received: ',
  my_certificate: 'My certificate',
  no_certificate: 'You have no certificate yet',
  custom_theme: 'Customized topic',
  course_topics: 'Course topic',
  no_permission_learn: 'You have no permission to learn the resource',
  points_acquisition_details: 'Point Details',
  date: 'YYYY-MM-DD',
  total_points: 'Total Point',
  points_rules: 'Credit rules',
  check_exam: '0404Web-View exam',
  examination_time: 'Exam time:',
  min_score: 'Qualified: {minScore}',
  total_score_detail: 'Full score: {totalScore}',
  question_num: 'Question number: {questionNum} questions',
  learnTime_num: '观看/收听时长至少{learnTime}分钟已学',
  learnTime_zero: '点击即算已学',
  show_exam_list: '0403Web-Show my homework list',
  resource_center: 'Resource center',
  edit: 'Edit',
  edit_avatar: 'Edit avatar',
  avatar: 'Avatar',
  upload_files_failed: 'Failed to upload image',
  upload_files_success: 'Uploaded successfully',
  upload_again: 'Re-upload',
  preview_head_image: 'Avatar preview',
  current_identity: 'Current identity',
  switch: 'Switch',
  learn_time: 'Learning Duration',
  learn_num: 'Learning Times',
  learn_course: 'Course(s) Learned',
  files_size_limit_tip: 'The image should be less than 2M, please control the image size',
  support_type_img: 'Only images in JPG and PNG formats are allowed, please make sure the format is correct.' ,
  certificate: 'Certificates',
  passwoed_not_empty: 'The old password, password and confirm password cannot be empty!' ,
  old_password: 'Old Password',
  enter_old_password: 'Please enter the old password',
  pwd_format_error: 'Incorrect password format',
  new_password: 'New Password',
  enter_pwd_rules: 'Please enter at least 8 alphanumeric characters',
  confirm_pwd_error: "Two passwords do not match",
  confirm_pwd: "Confirm the Password",
  enter_pwd_again: 'Please enter your password again',
  reset_pwd_success: "Congratulations! Reset password successfully!" ,
  go_back_home: "Return to homepage",
  sevice_error: 'Server error!' ,
  client_error: 'Client error!' ,
  login_again_please: 'For your account security, please log in again',
  account_out_time: "Your account has timed out, please log in again" ,
  zhiniao_portal: 'Smart Learn Platform',
  zhiniao_web_page: "Smart Learn web version",
  quit: 'Exit',
  download: 'Download',
  imprint: 'Print',
  submit: 'Submit',
  nothing: 'None',
  comment_click: 'Comments',
  updated_btn: 'Refresh',
  not_yet_course: 'No courses yet',
  post_count: '{postCount, plural, =0 {no posts.} =1 {one post.} other {# posts.}}',
  give_score: 'Rating',
  no_data_yet: 'No content yet',
  which_level: 'Level {num}',
  person_num: "{num}",
  emojiImg: 'Stickers',

  step_learn: 'Stage learning project',
  living_replay: 'Live replay',
  phone_num: 'Mobile Phone No. should be 8 digits',
  pwd_length: 'password length should not exceed 16 digits',
  learn_typeName: 'Learn {typeName}「{name}」',
  share_typeName: 'Share {typeName}「{name}」',
  commend_typeName: 'Rated {typeName}「{name}」',
  collect_typeName: 'Add to favorites {typeName}「{name}」',
  look_typeName: 'View {typeName}「{name}」',
  host_typeName: 'Host {typeName}「{name}」',
  gift_typeName: 'Rewarded {typeName}「{name}」',
  completed_typeName: '{typeName}「{name}」completed the training',
  chuangguan_typeName: '{typeName}「{name} task completed」',
  participate_typeName: 'Participate in {typeName}「{name}」{score}',
  grades_score: ', grade: {score}',
  read_typeName: 'Read {typeName}「{name}」',
  comment_typeName: 'Comment {typeName}「{name}」',
  participate_in_training: 'Participate in training {typeName}「{name}」{score}',
  result_durationStr: '{result}, duration {durationStr}',
  typeValue_trainClassName: 'Participate in {typeValue}「{trainClassName}」',
  totalScoreStr: '{totalScoreStr} Points',
  pic_i_extend: 'Picture{i}.{extend}',
  latest_release: 'Latest Released',
  registered: 'Registered',
  quantity: '{quantity}',

  voice_playing:'Audio living',
  voice_back_playing:'Audio live playback',
  face_to_face_teaching:'Face to Face',
  // face_to_face_teaching:'OMO trainings',
  // voice_playing:'Voice live in progress',
  // voice_back_playing:'Voice replay in progress',

  no_reviewed:'Not Reviewed',
  myOrder:'My Orders',
  and_too:'and',
  cloud_school_project:'Cloud Institution training details page',
  cloud_school_project_list:'Cloud Institution training public list',
  case_study_questions:'Case study question',
  acknowledge:'Confirm',
  submitted:'Submitted',
  invoicing_info_submitted:'Submitted Invoicing Info',
  invoice_applied:'Invoicing has been requested',
  Invoiced:'Invoiced',
  audit_failed:'Rejected',
  revoked:'Withdrawn',
  cancel_invoice_request:'Withdraw the invoice application?' ,
  submit_invoice_request:'Submit the invoice application?' ,
  submit_application:'Submit Application',
  modify_application:'Modify Application',
  application_canceled:'Withdraw Application',
  lump_sum_colon:'Total Amount:',
  enter_email_address:'Please enter your email address',
  email_address_colon:'Email Address:',
  enter_mailing_address:'Please enter your mailing address',
  mailing_address_colon:'Mailing Address:',
  enter_connect_num:'Please enter your Mobile Number',
  connect_num_colon:'Mobile Number:',
  electronic_Invoice:'E-invoice',
  paper_Invoice:'Paper Invoice',
  billing_method:'Invoicing Method:',
  enter_bank_account:'Please enter the bank account',
  bank_account_num:'Bank Account:',
  enter_opening_bank:'Please enter the deposit bank',
  opening_bank:'Deposit Bank:',
  enter_registered_number:'Please enter the registration phone number',
  registered_number:'Registration Phone Number:',
  enter_registered_address:'Please enter the registered address',
  registered_address:'Registered Address:',
  enter_tax_number:'Please enter the company tax ID',
  tax_number:'Company Tax ID:',
  enter_company_title:'Please enter the company name',
  company_title:'Company Name:',
  mpre_content:'More:',
  business_unit:'Corporate Unit',
  individuals_corporate_units:'Individual / Non-corporate unit',
  header_type:'Type of Title:',
  ordinary_invoice:'General Invoice',
  value_added_tax:'Special Invoice of Value-added Tax',
  invoice_type:'Invoice Type:',
  Invoice_Information:'Invoice Info',
  Apply_invoice:'Apply for Invoicing',
  Apply_time:'Application Time:',
  company_title_empty:'Company name cannot be empty',
  company_tax_num_empty:'Company tax ID cannot be empty',
  company_tax_limit:'Company tax ID can only consist of alphanumeric or characters',
  registered_address_empty:'Registered address cannot be empty',
  registered_number_empty:'Registered phone number cannot be empty',
  opening_bank_empty:'Deposit bank cannot be empty',
  bank_account_empty:'Bank account cannot be empty',
  connect_num_empty:'Mobile Number cannot be empty',
  mailing_address_empty:'Mailing address can not be empty',
  amail_address_empty:'Email address cannot be empty',
  enter_true_email:'Please fill in the correct email address',
  rate_speed:'x',
  unLockTime:'It will unlock at {unLockTime} ~',
  open_zhiniao:'Please open the Smart Learn App to complete the assignment',
  correct_answer:'Correct Answer',
  my_answers:'My Answer',
  after_start_exam:'When the exam has started, {text}, otherwise the exam will be deemed by the system to have been finished.' ,
  not_close_brower:"please don't close the browser or exit the exam screen",
  administrator_to_unblock:'The upper limit of screen toggles has been reached, you may not re-enter the exam. Please contact admins to unblock',
  keep_screen_max:'Please always keep the exam window maximized, otherwise the exam cannot be started',
  warning:'Warning',
  cut_screen_times:'Screen toggling is prohibited during this exam. After reaching {maxTimes} times, you will be considered as cheating and paper will be automatically handed in',
  cut_screen_maxTimes:'You have left the interface {maxTimes} time(s)! Paper has been automatically handed in',
  cheating_times:'You have left the interface {maxTimes} time(s)! After leaving the exam for {remainderTimes} more time(s), you will be considered as cheating and paper will be automatically handed in?',
  examing_limit_tips:'Please do not close the browser or exit the exam screen when the exam is in progress!' ,
  purchased_course:'Purchased Courses',
  study_card:'Study Cards Courses',
  my_training_project:'My Trainings',
  resource_duration:'{resourceDuration} credit hour(s)',
  regular:'Normal',
  end_data:'Due date: {expireDate}',
  study_card_cover:'Study Cards Cover',
  terminated:'Deactivated',
  expired:'Expired',
  studyCard:'Study Cards',
  zhiniao_cloud:'Smart Learn Knowledge Cloud',
  go_cloud_home:'The enterprise logged in has no access to this knowledge space, the system will switch to the homepage of Knowledge Cloud',
  refund_amount:'Refund Amount (CNY):',
  detail_useNum:'Used People: {useNum}',
  refund_num:'Number of Refunds (person):',
  apply_refund:'Apply for Refund',
  check_refund_detail:'Refunded, view refund details',
  check_refund_record:'View Refund History',
  apay_time_colon:'Payment Time:',
  order_time:'Order Time:',
  order_num:'Order No.:',
  real_payment:'Actual Payment:',
  no_coupons_available:'No coupons available',
  pay_format:'Payment method:',
  coupons_colon:'Coupon:',
  student_colon:'Student:',
  student_info:'Student Info:',
  total_price:'Total Price:',
  transaction_complete:'Transaction Completed',
  order_details:'Order Details',
  apply_refund_success:'Refund applied successfully',
  refund_price_zero:'Refund amount cannot be 0',
  refund_num_zero:'Refund quantity cannot be 0',
  max_refund_num:'Refund quantity cannot be greater than unused quantity',
  max_refund_price:'Refund amount cannot be greater than order amount',
  all_refund:'Total Refund',
  part_refund:'Partial Refund',
  refund_failed:'Refund Failed',
  apply_refund_fee:'Apply for Refund',
  business_business_transfer:'B2B Transfer',
  WeChat_Pay:'WeChat Pay',
  pay_by_AliPay:'Alipay',
  Cancelled:'Cancelled',
  Paid:'Paid',
  to_be_confirmed:'Pending Confirmation',
  to_be_paid:'Unpaid',
  check_item:'View item',
  invoice_record:'Invoicing history',
  no_my_order:'No orders yet',
  Refund_after_sale:'Refund',
  price_from_text:"From {text}",
  price_from:"From ",
  period_Total:'{periodTotal} credit hours',
  training_duration_colon:'Training Hours:',
  no_my_training_item:'No trainings yet',
  leran_precess:'Learning Progress',
  complete_duration_count:'Completed {completedHours}/{requiredHours} credit hours',
  remainHours_duration_count:'{remainHours} credit hour(s) left',
  buy_duration_count:'Purchased {remainHours} credit hour(s)',
  register_now:'Sign-Up Now',
  Register_start_learning:'Sign-up for the current training to start studying',
  training_project_no_start:'Trainings has not started yet!' ,
  export_learn_report:'Export learning report',
  export_data_empty:'Export data cannot be empty!' ,
  Check_is_blocked:'1. Check if it is blocked: the prompt as shown appears in the upper right corner of the browser',
  click_intercept_icon:'2. Click the blocking icon and change the option to "Allow to display"',
  refresh_the_webpage:'3. Refresh the page and click "Top-Up" again',
  complete_fee_tips:'If you have completed {feeWay1}, please click "Completed {feeWay2}"',
  sign_up:'Sign-Up',
  Recharge:'Top-Up',
  opration_follow_steps:'If the system failed to open the system top-up page, please follow the steps below',
  company_feeWay:'Completed {feeWay}',
  click_on:'Click',
  cross_domain_image:'This is a cross-domain picture',
  cross_regional_picture:'Get a cross-domain picture',
  Statistics_Time:'Stat Time:',
  learned_availid_duration:'Valid credit hours completed:',
  Organization:'Organization:',
  Position_type_work:'Post (job type):',
  Credentials:'Certificate:',
  mobile_number_colon:'Mobile Number:',
  staff_code:'Employee ID:',
  gender:'Gender:',
  name_colon:'Name:',
  basic_information:'Basic Info',
  training_project_colon:'Trainings:',
  personal_learning_report:'Personal learning report of training',
  page_num:'Page Number: {index}/{arr}',
  data_from_colon:'Data Source:',
  catalog_list:'Catalog({resourcesCount})',
  learned_no_refund:'No refunds will be available after online course has been taken',
  refrash_duration:'Credit hour upgrade',
  i_go_sign_up:'I want to sign up',
  refunding_tips:'Refund in progress, cannot {headDateil}',
  pageFrom_project:'{pageFrom} trainings',
  mine:'Me',
  project_study_report:'Personal learning report of training',
  Pre_school_verification:'Real name authentication of pre-learning verification',
  product_info:'Product Info',
  Specification:'Specifications',
  trading_status:'Transaction Status',
  refund_details:'Refund Details',
  completed_time_colon:'Completion Time:',
  sum_price:'Total Amount',
  payment_real:'Actual Payment',
  RESOURCE_TYPE_team:'{RESOURCE_TYPE} (group)',
  coursePeriod_duration:'{coursePeriod} credit hours',
  buyers_Num:'{buyersNum} person(s)',
  study_information:'Student Info',
  order_information:'Buyer Info',
  student_name_colon:'Student Name:',
  phone_num_colon:'Mobile Number:',
  order_info:'Order Info',
  pay_time_colon:'Payment Time:',
  no_available_coupons:'No coupons available',
  refund_amount_colon:'Refund Amount:',
  refund_colon:'Refund:',
  Public_public_payment:'B2B Payment',
  Refund_under_review:'Refund under review',
  Payment_time_colon:'Payment Time:',
  school_short_video:'Learning School Clips',
  school_live:'Learning School Live',
  pay_success_confirm:'Paid successfully',
  pay_failed:'Paid Failed',
  WeChat_payment_limit:'Please note the transaction limit of WeChat Pay. If payment is unavailable, you can try to use Alipay.' ,
  means_transaction:'Transaction Method',
  pay_money:'CNY{payMoney}',
  transaction_amount:'Transaction Amount',
  use_WeChat_scan:'Please use WeChat to scan the code to pay',
  sevice_qus_connect:'If you have questions about Smart Learn’s purchase service, please call: 400-603-8258 during office hours on legal business days (9:00-12:00, 13:30-18:00) to contact our customer service',
  upgrade_immediately:'Upgrade Now',
  Amounts_payable:'Amount Payable:',
  order_total_price:'Total Order Price: {text}',
  Payment_Information:'Payment Info:',
  payment_method:'Payment Method:',
  After_upgrade:'After Upgrade:',
  pre_upgrade:'Before Upgrade:',
  select_upgraded_specification:'Please select upgraded specifications:',
  identity_number:'ID No.:',
  complete_student_information:'Please improve the student info',
  total_periodTotal:'{periodTotal} credit hour(s)',
  enter_identity_numbe:'Please enter the correct ID number',
  enter_stu_name:'Please enter the student‘s name',
  Certificate_being_generated:'Generating certificate, please check later',
  click_course_duration:'After courseware is clicked and played, credit hours will be consumed',
  buy_duration_learn:'Please purchase credit hours to continue learning',
  select_more_look:'For centralized watching, please select [Multi-watching], then the learning records will be counted for those on-site users, and learning rewards will be provided!' ,
  sign_QR_code:'Sign-in QR code_{roomId}.png',
  QR_code_no_exist:'QR code address does not exist!' ,
  use_app_login:'For on-site users signed in by scanning codes with Smart Learn App, please do not leave after signing in, as signing out is also required when the activity is over!',
  scon_code_login:'Scan to Sign In',
  after_sign_up:'After signing in, confirm to signing out later!',
  scan_left_code:'Smart Learn App - Scan in the upper left corner',
  watching_intensively:'For centralized watching, audience can earn credits by scanning codes to sign in and sign out and draw the luxury prize!',
  enter_live_sign:'Enter the live room to continue to sign in',
  scan_look:'Scan to Watch',
  sign_QR_code_room:'Sign-In QR Code_{roomId}',
  et_up_centralized:'First of all, please set the location for centralized watching, and on-site users will sign in and out within that location',
  lower_meters:'m (=1000m)',
  zhiniao_meeting:'Smart Learn Meeting',
  cloud_school_end:'The current cloud meeting has closed',
  hours_ago:'{h}hour(s)',
  hours_min_detail:'{h}hour(s){m}minute(s)',
  few_minutes:'{m}minute(s)',
  use_other_browers:'Please use another browser to open or copy the link to another browser to open',
  meeting_num:'Meeting ID:',
  host_room_colon:'Host:',
  phone_meeting:'Join by Mobile',
  enter_meeting:'Join',
  scan_code_enter:'Scan the code to join the cloud meeting',
  Arousing_client:'Client is being evoked...',
  Arousing_failed:'If it is not installed or evoking failed, please click ',
  download_client:'Download the Client',
  admin_set_replay:'The creditors "meeting has ended. If you want to watch, please contact admins to set replay!"',
  live_end_replay:'The live has ended. If you want to watch, please contact admins to set replay!?',
  check_in_ahead_time:'Please sign in before!' ,
  Remember_complete_checkout:'Please sign out after!' ,
  panelText_QR_code:'{panelText} QR code_{roomId}',
  QR_code_loading:'Loading QR code...' ,
  Draw_luxury_prizes:'For centralized watching, audience can earn credits by scanning codes to sign in and sign out and draw the luxury prize!',
  scan_panelText:'Scan Code {panelText}',
  currently_playing:'What is currently playing is the current video',
  next_video:'Next Clip',
  add_look_data:'For department centralized watching, you can click to open the QR code for centralized watching on the right side to include the activity into departmental watching data.' ,
  looking_sign_every_time:'Watching, you can open the sign-in code at any time to let audience who have not signed in to make up',
  learnd_need_sign:'After watching, you need to open the sign-out QR code, and on-site users need to sign out to include the activity into learning data',

  Password_live_room:"Password Live Room",
  enter_live_room:"Enter Live Room",
  apply_live:"Live Application",
  enter_go_live:"Click here to apply for live~",
  enter_Password_live:"Enter the password to start the live",
  people_num_icon:'Icon of people number',
  Service_Agreement:'Service Agreement' ,
  Zhiniao_Privacy_Polic: 'Smart Learn Privacy Policy',
  Ping_An_Software_Agreement:'Ping An Smart Learn Software License and Service Agreement',
  knowledge_cloud:"Knowledge Cloud",

  click_btn_verify:'Click to verify',
  study_card_paid: 'Purchased Cards',
  question_bank: 'Question Pool',
  job_develop_path: 'JobDevelopPath',
  answer_questions: 'Please answer questions based on the above material:',

  total_amount: 'Total Price:￥{totalAmount}',
  to_start: 'To be started',
  word: 'Password',
}
